import { render, staticRenderFns } from "./formatGuide.vue?vue&type=template&id=674bb688&"
import script from "./formatGuide.vue?vue&type=script&lang=js&"
export * from "./formatGuide.vue?vue&type=script&lang=js&"
import style0 from "./formatGuide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports